import * as React from 'react';
import { observer } from 'mobx-react';
import * as classnames from 'classnames';
import { CheckboxFilter } from './CheckboxFilter';
import { ButtonFilter } from './ButtonFilter';

export interface ITagFilterButton {
    onSelectFilterClick(): void;
    isSelected: boolean;
    label: string;
    disabled?: boolean;
    checkboxFilter?: boolean;
}

export const CategoryFiltersButton = observer((props: ITagFilterButton) => {
    const className = classnames({
        'elc-styled-filters-category-button': true,
        'elc-styled-filters-category-button--selected': true
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const FilterItem: any = props.checkboxFilter ? CheckboxFilter : ButtonFilter;

    return (
        <FilterItem
            className={className}
            onFilterSelect={props.onSelectFilterClick}
            disabled={props.disabled}
            label={props.label}
            isSelected={props.isSelected}
        />
    );
});
